import React from "react";
import { Box, Drawer, Toolbar } from "@mui/material";
import AppAppBar from "./AppAppBar";
import { Outlet } from 'react-router-dom';

const drawerWidth = 255;

function MobileDrawer({ drawer, drawerOpen, handleDrawerClose }) {
  return (
    <Drawer
      onBackdropClick={handleDrawerClose}
      variant="temporary"
      anchor="left"
      open={drawerOpen}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', borderColor: 'black' },
      }}
    >
      <Toolbar />
      {drawer}
    </Drawer>
  );
}

function DesktopDrawer({ drawer }) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', borderColor: 'black' },
      }}
    >
      <Toolbar />
      {drawer}
    </Drawer>
  );
}
 
export default function DashboardScreenLayout({ drawerOpen, setDrawerOpen, isWide, drawer, userInfo, refresh, setRefresh }) {

  const handleDrawerClose = () => setDrawerOpen(false);

  // if mobile, uses these props
  const props = !isWide && {
    open: drawerOpen,
    setOpen: setDrawerOpen
  };;

  return (
    <React.Fragment>
      <AppAppBar {...props} />
      <Box sx={{ display: 'flex' }}>
        {isWide ? 
          <DesktopDrawer drawer={drawer} /> 
          : 
          <MobileDrawer drawer={drawer} drawerOpen={drawerOpen} handleDrawerClose={handleDrawerClose} />
        }
        <Outlet context={[userInfo, refresh, setRefresh]} />
      </Box>
    </React.Fragment>
  );
}